import { z } from "zod";
import {
  directoryListResponseSchema,
  directoryRoleSchema,
  directoryRowSchema,
} from "@/shared/membership/directory.schema";

/// The base directory primitives (enums, directoryRowSchema, ListDirectoryQuery,
/// directoryListResponseSchema) moved to `@/shared/membership/directory.schema`
/// in the C2 deepening (2026-05-23), they're consumed by feedback, kudos,
/// one-on-one, todos. This file keeps the people-specific extensions: detail
/// page, stats card, and the /my-reports response shape.

/** Response shape for `/my-reports`, adds a `mode` flag so the UI knows
 *  whether the rows are the caller's reports, their peer team, or empty. */
export const myReportsResponseSchema = directoryListResponseSchema.extend({
  mode: z.enum(["reports", "peers", "empty"]),
});
export type MyReportsResponse = z.infer<typeof myReportsResponseSchema>;

export const directoryStatsSchema = z.object({
  total: z.number().int(),
  admins: z.number().int(),
  managers: z.number().int(),
  members: z.number().int(),
  pendingInvitations: z.number().int(),
});
export type DirectoryStats = z.infer<typeof directoryStatsSchema>;

const managerChainEntrySchema = z.object({
  depth: z.number().int(),
  managerMembership: z.object({
    membershipId: z.string(),
    userId: z.string(),
    displayName: z.string(),
    avatarUrl: z.string().nullable(),
    role: directoryRoleSchema,
    title: z.string().nullable(),
  }),
});

const directReportSchema = z.object({
  membershipId: z.string(),
  userId: z.string(),
  displayName: z.string(),
  avatarUrl: z.string().nullable(),
  role: directoryRoleSchema,
  title: z.string().nullable(),
});

export const directoryDetailSchema = directoryRowSchema.extend({
  managerChain: z.array(managerChainEntrySchema),
  directReports: z.array(directReportSchema),
});
export type DirectoryDetail = z.infer<typeof directoryDetailSchema>;
